import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

//Components
import LanguageSelect from '../LanguageSelect';
import MenuHeaderMobile from '../MenuHeaderMobile';
import MenuHeader from '../MenuHeader';
import MiniCart from '../MiniCart';
import Badge from '@mui/material/Badge';
import MyAccount from '../MyAccount';
import AlertConfirm from '../AlertConfirm';
import Alert from '../Alert';
import CircularProgress from '@mui/material/CircularProgress';

// Queries
import postGlobal from '../Queries/postGlobal';
import getLogin from '../Queries/getOpenOrder';

// Images
import LOGO from '../../images/sign/logo.png';

// Styles
import styles from './index.module.sass';
const country = process.env.REACT_APP_COUNTRY;

export default function Header({
  getCookie,
  history,
  match,
  orderData,
  setOrderData,
  webservice,
  screenSize,
  setSessionMessage,
  pathname,
}) {
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showMenu, setshowMenu] = useState(false);
  const [show, setshow] = useState(false);
  const [itemSelectedAccount, setItemSelectedAccount] = useState(null);
  const [intemsCount, setItemsCount] = useState(0);
  const [openMiniCart, setOpenMiniCart] = useState(false);
  const { t } = useTranslation('menuheader');
  const [nextRoute, setNextRoute] = useState('');
  const [loading, setLoading] = useState(false);
  const [badgeLoading, setBadgeLoading] = useState(false);
  const [isConsultancy, setIsConsultancy] = useState(true);

  useEffect(() => {
    setItemsCount(0);
    const orderItems = orderData?.detallePedido || [];
    for (let i = 0; i < orderItems.length; i++) {
      const { cantidad = 0 } = orderItems[i];
      setItemsCount((oldData) => {
        return oldData + parseInt(cantidad);
      });
    }
  }, [orderData]);

  function handelDialog(action, messaje, route) {
    if (messaje) setAlertText(messaje);
    setOpen(action);
    if (route) setNextRoute(route);
    if (!action && nextRoute) history.push(nextRoute);
  }

  const getOrder = useCallback(
    async (action, cat, id, quantity, lineNum, neddLoading) => {
      setBadgeLoading(true);
      const order = await postGlobal({
        tmbservice: 'getAgregarAlCarrito',
        jsonBody: {
          accion: action,
          usuarioOK: getCookie('usuarioOk'),
          folioPedido: getCookie('folioPedido'),
          almacen: getCookie('warehouse'),
          categoria: cat,
          clave: id,
          cantidad: quantity,
          numeroLinea: lineNum,
          textoProdSeleccion: '',
          idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
          origen: 'CARRITONUE',
        },
      });

      setSessionMessage(order?.mensaje || '');

      setOrderData(order || {});
      setBadgeLoading(false);
    },
    [getCookie, setOrderData, setSessionMessage],
  );

  useEffect(() => {
    if (pathname.includes('consultancy')) {
      setIsConsultancy(true);
      return;
    }
    setIsConsultancy(false);
  }, [t, pathname]);

  useEffect(() => {
    if (!isConsultancy)
      getOrder(`${(country === 'MX' && 'CONSULTAR') || 'CONSULTARWEB'}`, '', '', '', '', true);
  }, [getOrder, isConsultancy]);

  let miniCartTimeout;

  function menu() {
    setshowMenu(false);
    setshow(false);
    setItemSelectedAccount(false);
  }

  async function verifyStatus(e) {
    setLoading(true);
    const response = await getLogin('N');
    const { getLoginResult = [] } = response || {};

    if (getLoginResult.length > 0) {
      const {
        tipoMensaje = 'error',
        folioPedido = '',
        usuarioOk = '',
        usuario = '',
        nombre = '',
        apPaterno = '',
        almacen = '',
        mensaje = '',
      } = getLoginResult[0];

      if (mensaje === '498' || mensaje === '499') {
        setSessionMessage(mensaje);
      } else if (tipoMensaje === 'error' && folioPedido !== '') {
        setAlertText(t('reopen'));
        setLoading(false);
        setOpenAlert(true);
      } else if (tipoMensaje === 'error' && folioPedido === '') {
        setAlertText(mensaje);
        setOpen(true);
        setLoading(false);
      } else {
        const now = new Date();
        const time = now.getTime();
        const expireTime = time + 1000 * 36000;
        now.setTime(expireTime);
        document.cookie = `folioPedido=${folioPedido};expires=${now.toUTCString()};path=/`;
        document.cookie = `usuarioOk=${usuarioOk};expires=${now.toUTCString()};path=/`;
        document.cookie = `usuario=${usuario};expires=${now.toUTCString()};path=/`;
        document.cookie = `kitName=${nombre} ${apPaterno};expires=${now.toUTCString()};path=/`;
        document.cookie = `warehouse=${almacen};expires=${now.toUTCString()};path=/`;
        document.cookie = 'pedidoCerrado=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        setLoading(false);
        if (country === 'MX') {
          history.push('/cart/consultancy/warehouse');
        } else {
          history.push('/cart');
        }
      }
    } else {
      setAlertText(t('loginFailed'));
      setOpen(true);
      setLoading(false);
      return;
    }
  }

  return (
    <div id='Header' className={`${styles.header} ${styles[screenSize]}`}>
      <MenuHeaderMobile
        open={menuOpen}
        setOpen={setMenuOpen}
        showMenu={showMenu}
        setshowMenu={setshowMenu}
        show={show}
        setshow={setshow}
        itemSelectedAccount={itemSelectedAccount}
        setItemSelectedAccount={setItemSelectedAccount}
        history={history}
      />
      <AlertConfirm
        open={openAlert}
        setOpen={setOpenAlert}
        title='Terramar'
        text={alertText}
        usuarioOk={getCookie('usuarioOk')}
        history={history}
        setAlertText={setAlertText}
      />
      <Alert
        open={open}
        setOpen={setOpen}
        title={'Terramar'}
        text={alertText}
        callback={() => handelDialog(false)}
      />
      {screenSize === 'phone' && (
        <div className={styles.menuAndLanguage}>
          <i className={`material-icons ${styles.menuIcon}`} onClick={() => setMenuOpen(!menuOpen)}>
            menu
          </i>
          <span className={styles.titleIcon}>Menú</span>

          {menuOpen && !showMenu && (
            <i className={`material-icons ${styles.returnIcon}`} onClick={() => setMenuOpen(false)}>
              close
            </i>
          )}

          {menuOpen && showMenu && (
            <i className={`material-icons ${styles.returnIcon}`} onClick={() => menu()}>
              keyboard_backspace
            </i>
          )}
        </div>
      )}

      {screenSize !== 'phone' && (
        <>
          <div
            className={styles.logo}
            onClick={() => history.push(`${match.path}/consultancy/home`)}>
            <img src={LOGO} alt='logo' />
          </div>
          <div className={styles.centerMenu}>
            <MenuHeader history={history} screenSize={screenSize} />
          </div>
        </>
      )}
      {screenSize !== 'phone' && (
        <div className={styles.LanguageSelect}>
          <LanguageSelect />
        </div>
      )}
      <div className={styles.iconsRight}>
        {screenSize !== 'phone' && <MyAccount history={history} getCookie={getCookie} />}

        {screenSize !== 'phone' && (
          <div
            className={styles.shipmentContainer}
            onClick={() => history.push(`${match.path}/consultancy/shipments`)}>
            <i className={`material-icons-outlined ${styles.shipmentIcon}`}>local_shipping</i>
            <div className={styles.shipment}>{t('shipments')}</div>
          </div>
        )}

        {(pathname.includes('consultancy') && (
          <div
            className={styles.shopButton}
            onClick={(e) => {
              if (loading) return;
              verifyStatus(e);
            }}>
            {(loading && <CircularProgress className={styles.circularProgress} />) || (
              <>
                <i className={`material-icons-outlined ${styles.shopButtonIcon}`}>shopping_cart</i>
                {t('cart')}
              </>
            )}
          </div>
        )) || (
          <div
            className={styles.bagIcon}
            onMouseEnter={() => {
              clearTimeout(miniCartTimeout);
              setOpenMiniCart(true);
            }}
            onMouseLeave={() => {
              miniCartTimeout = setTimeout(function () {
                setOpenMiniCart(false);
              }, 1500);
            }}>
            <Badge
              badgeContent={
                (badgeLoading && <CircularProgress className={styles.badgeCircularProgress} />) ||
                intemsCount
              }
              sx={{
                '& .MuiBadge-badge': {
                  color: 'white',
                  backgroundColor: '#9b722a',
                },
              }}>
              <i
                className={`material-icons-outlined ${styles.shopIcon}`}
                onClick={() => history.push(`${match.path}/shoppingcart`)}>
                shopping_bag
              </i>
            </Badge>

            {screenSize !== 'phone' && (
              <div className={styles.miniCartContainer}>
                <MiniCart
                  screenSize={screenSize}
                  orderData={orderData}
                  history={history}
                  match={match}
                  setOpenMiniCart={setOpenMiniCart}
                  openMiniCart={openMiniCart}
                  getCookie={getCookie}
                  webservice={webservice}
                  setOrderData={setOrderData}
                  setSessionMessage={setSessionMessage}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
